import { classNames } from '@vkontakte/vkui';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { SHARING_VARIANT } from 'reactApp/components/SharingWindow/SharingNew/Weblink/WeblinkList/SharingNewWeblinkList.types';
import type { IACListItem } from 'reactApp/modules/folderAccessControlList/folderAccessControlList.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { Loader } from 'reactApp/ui/Loader/Loader';
import { createAvatarUrl } from 'reactApp/utils/avatar';

import { WeblinkUser } from '../User/WeblinkUser';
import styles from './UserList.css';
import type { IProps } from './WeblinkUserList.types';

export const WeblinkUserList = React.memo(function WeblinkUserList({
    acList,
    isLoading,
    isPhone,
    item,
    isReadOnly,
    isEmbeded,
    variant = SHARING_VARIANT.default,
}: IProps) {
    const email = useSelector(UserSelectors.getEmail);

    const owner = email
        ? {
              name: 'Вы',
              email,
              avatarUrl: createAvatarUrl(email),
          }
        : null;

    const renderItem = useCallback(
        (user) => (
            <div
                className={classNames(styles.user, {
                    [styles.user_embeded]: isEmbeded,
                    [styles.user_tab]: variant === SHARING_VARIANT.tabs,
                })}
                key={user.email}
            >
                <WeblinkUser
                    isEmbeded={isEmbeded}
                    user={user}
                    item={item}
                    publicId={item?.weblink}
                    isPhone={isPhone}
                    isReadOnly={isReadOnly}
                    variant={variant}
                />
            </div>
        ),
        [isEmbeded, item, isPhone, isReadOnly, variant]
    );

    return (
        <div
            className={classNames(styles.root, {
                [styles.root_phone]: isPhone,
                [styles.root_tabs]: variant === SHARING_VARIANT.tabs,
            })}
        >
            <div
                className={classNames(styles.usersList, {
                    [styles.usersList_scroll]: acList.length > 2,
                    [styles.usersList_embeded]: isEmbeded,
                })}
            >
                {isLoading ? (
                    <div className={styles.loading}>
                        <Loader centered isModal />
                    </div>
                ) : (
                    <>
                        {Boolean(owner) && (
                            <div
                                className={classNames(styles.user, {
                                    [styles.user_embeded]: isEmbeded,
                                    [styles.user_tab]: variant === SHARING_VARIANT.tabs,
                                })}
                            >
                                <WeblinkUser
                                    user={owner as IACListItem}
                                    isPhone={isPhone}
                                    isOwner
                                    isReadOnly={isReadOnly}
                                    variant={variant}
                                    isEmbeded={isEmbeded}
                                />
                            </div>
                        )}
                        {acList.map((user) => renderItem(user))}
                    </>
                )}
            </div>
        </div>
    );
});
